import script from "./CountDown.vue?vue&type=script&setup=true&lang=js"
export * from "./CountDown.vue?vue&type=script&setup=true&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=792aea34&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792aea34"]])

export default __exports__